<template>
  <ORow fill-x stretch-x>
    <div style="width: 200px">
      {{ config.toString() }}
    </div>

    <div style="flex-grow: 1">
      <LineChart
        class="border-sparkline"
        :data="points"
        xProp="timestamp"
        yProp="value"
        :height="30"
        :width="500"
        @highlight="(x) => (highlighted = x)"
      />
    </div>

    <div style="width: 100px">
      <v-btn icon @click="copyPlot">
        <v-icon small>mdi-clipboard-outline</v-icon>
      </v-btn>
    </div>

    <div v-if="highlighted != null">
      {{ highlighted.timestamp | moment('DD/MMM/YYYY HH:mm:ss') }}
      : <b>{{ highlighted.value }}</b>
      (0x{{highlighted.value | hex}})
      <b v-if="highlighted.cardLabel != null">{{ highlighted.cardLabel }}</b>
    </div>

  </ORow>
</template>

<script>
import LineChart from '../../../components/LineChart.vue'

export default {
  components: { LineChart },
  props: {
    // "rows" é uma lista de objetos como lapsos (quando usando
    // o formato novo, de ops genéricas com payload can-sniff).
    // Cada row deve portanto ser da forma:
    // { timestamp: Date, sample: Array<CANSniffSample> }
    //
    // Observe que, se o pgn da PlotConfig é na verdade uma
    // variável de rawdata (e.g. "rpm", "speed", etc) então
    // ao invés de ser buscada no sample, ela será buscada
    // diretamente na row.
    rows: { required: true },

    // @type {PlotConfig}
    // config: {pgn: String, startBit: Number, endBit: Number}
    // start vai de 0 até 63, end vai de 1 até 64 (exclusive)
    config: { required: true }
  },
  data() {
    return { points: [], highlighted: null }
  },
  mounted() {
    this.points = this.computePoints()
  },
  methods: {
    computePoints() {
      const pgn = this.config.pgn

      const result = this.rows.map((row) => {
        const timestamp = row.timestamp

        // Se temos um valor para o pgn diretamente na row,
        // já retorna esse valor. Isso acontece quando o pgn
        // é na verdade uma variável de rawdata (speed, rpm, etc)
        if ( row.lapse && row.lapse[pgn] != null ) {
          return { timestamp, value: row[pgn] }
        }

        // Se não está diretamente na row, assume que devemos
        // procurar a linha correspondente no sample.
        const sample = row.sample || []
        const corresp = sample.find((x) => x.code == pgn)
        if (corresp == null) {
          return { timestamp, value: 0 }
        } else {
          // delete para a PlotConfig buscar o value,
          // porque ela pode ter regras de endianess
          const value = this.config.getValue(corresp.bigValue)
          return { timestamp, value }
        }
      })

      return result
    },

    copyPlot() {
      let lines = this.points.map((p) => {
        return [
          this.config.toString(),
          p.timestamp.toISOString(),
          p.value,
          p.cardLabel
        ].join(';')
      })

      lines.unshift('pgn;timestamp;value;card')

      let str = lines.join('\n')
      navigator.clipboard.writeText(str)
      this.$snack('Copiado para o clipboard')
    }
  }
}
</script>

<style lang="sass">
.border-sparkline
  .bar-chart
    border: 1px solid #efefef
</style>
